<template>
  <footer>
    <div class="width">
      <div class="company-info">
        <img class="logo" :src="require('@/assets/dver-logo.svg')" />
        <div class="info-wrap">
          <div class="info">
            <div class="title">회사소개</div>
            <span
              style="cursor: pointer"
              class="content"
              @click="openUrl(url.dvercorp)"
              >dver corp.</span
            >
          </div>
          <div class="info">
            <div class="title">제휴문의</div>
            <span class="content">help@dvercorp.co.kr</span>
          </div>
        </div>
      </div>
      <div class="company-cs">
        <div class="info-wrap">
          <div class="info" style="margin-bottom: 12px">
            <div class="title">대표번호</div>
            <div class="content">1544 - 4805</div>
          </div>
          <div class="info for-flex">
            <div class="title">운영시간</div>
            <div class="content">
              평일 08:00 - 22:00 <br class="only-mobile" />/ 주말 및 공휴일
              08:00 - 21:00
            </div>
          </div>
        </div>
        <div class="social-list">
          <img
            @click="openUrl(url.blog)"
            :src="require('@/assets/img/ic_blog.svg')"
          />
          <img
            @click="openUrl(url.instagram)"
            :src="require('@/assets/img/ic_instagram.svg')"
          />
          <img
            @click="openUrl(url.youtube)"
            :src="require('@/assets/img/ic_youtube.svg')"
          />
        </div>
      </div>
      <hr />
      <div class="company-address">
        <div class="address">
          (주)디버 | 대표 : 장승래 | 서울특별시 마포구 독막로 301, 4층 일양빌딩
          별관(염리동, 일양빌딩)
        </div>
        <div class="business">
          사업자등록번호 457-81-01693 | 통신판매업신고번호 2024-서울마포-0911 |
          화물운송주선사업자 제 140171호 | 벤처기업인증 제 20220928010013호
        </div>
        <div class="copyright">
          Copyright © 2023 dver corp. All rights reserved
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { GIT_REV } from "@/constants/env";

export default {
  name: "Footer",
  data() {
    return {
      ENV: {},
      url: {
        blog: "https://blog.naver.com/dver_official",
        instagram: "https://www.instagram.com/dver_fit_u/",
        dvercorp: "https://www.dvercorp.co.kr/",
        youtube: "https://www.youtube.com/@dver2953/featured"
      }
    };
  },
  methods: {
    openUrl(url) {
      window.open(url);
    }
  },
  mounted() {
    this.ENV = GIT_REV;
  }
};
</script>
<style src="./footer.css" scoped></style>
